export const AttachmentTypeEnum = {
  SIGNED_CONSENT_TERM: "signed_consent_term",
  ADITIONAL_FILE: "aditional_file",
};
